module.exports = __webpack_public_path__ + "img/stock3.df54fee2.png";